import FileSearchIcon from "@/components/Icons/SVG/file-search.svg";
import { useRouteError } from "react-router-dom";

const ErrorFallback = () => {
  const error = useRouteError() as any;
  const goToHome = () => {
    window.location.href = "/";
  };
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-[#F5F3f0] dark:bg-[#15161D]">
      <img src={FileSearchIcon} width="100%" height={300} alt="file-search icon" className="h-[25rem]" />
      <p className="mt-6 text-xl font-bold text-gray-800 dark:text-gray-100">
        Oops! Something went wrong.
      </p>
      <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
        We're sorry, but we couldn't load this page.
      </p>
      {error && <pre style={{ color: "red", fontSize: "12px",marginTop: "1rem" }}>An unexpected error occurred</pre>}
      <div className="mt-4 flex items-center justify-center gap-4">
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-4 rounded-lg bg-blue-600 px-6 py-2 text-sm text-white hover:bg-blue-700"
        >
          Reload
        </button>
        <button
          onClick={goToHome}
          className="mt-4 rounded-lg bg-primaryColor px-6 py-2 text-sm text-white hover:bg-green-700"
        >
          Go Home
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
